import React, { forwardRef } from 'react'
import { Icon, iconDefaultProps, IconProps } from '../Icon'

type LayersTwo01IconProps = IconProps

const LayersTwo01Icon = forwardRef<SVGSVGElement, LayersTwo01IconProps>(
  (props: LayersTwo01IconProps, ref) => (
    <Icon {...props} ref={ref}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="m2 14.5 9.642 4.821c.131.066.197.099.266.111.06.012.123.012.184 0 .069-.012.135-.045.266-.11L22 14.5m-20-5 9.642-4.821c.131-.066.197-.098.266-.111a.5.5 0 0 1 .184 0c.069.013.135.045.266.111L22 9.5l-9.642 4.821a1.028 1.028 0 0 1-.266.111.501.501 0 0 1-.184 0c-.069-.012-.135-.045-.266-.11L2 9.5Z"
        fill="none"
      ></path>
    </Icon>
  ),
)

LayersTwo01Icon.displayName = 'LayersTwo01Icon'
LayersTwo01Icon.defaultProps = iconDefaultProps

export type { LayersTwo01IconProps }
export { LayersTwo01Icon }
